import { Outlet } from "react-router-dom";
import { MessagePage } from "@dealer-center/core-custom-components";
import { FailureState } from "@dealer-center/core-errors";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";

export const DealerIndex = () => {
  const { isLoading, error, data } = useGetAccount();
  if (isLoading)
    return (
      <MessagePage
        actionName={"Loading dealer state"}
        message="Loading dealer information"
      />
    );
  if (error) return <FailureState error={new Error(`Error loading dealer`)} />;

  return <Outlet context={{ accountEntity: data }} />;
};
